import { Component } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import Swal from 'sweetalert2';

@Component({

  selector: 'app-specialist-login',

  templateUrl: './specialist-login.component.html',

  styleUrls: ['./specialist-login.component.css']

})

export class SpecialistLoginComponent {

  isSubmitDisabled = false;

  fields = {
    strMobile: '',
    strUserPassword: ''
  };

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private accountService: AccountService,
    private otherService: OtherService,
    private router: Router,
  ) { }

  submit(phoneNumberField: NgModel, passwordField: NgModel) {
    if (phoneNumberField.invalid || phoneNumberField.pristine || passwordField.invalid || passwordField.pristine || this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;

    this.accountService.specialistLogin(this.fields).pipe(
      catchError(() => of(false)),
      takeUntil(this.unSubscribeAll$),
    ).subscribe((response: string | false) => {
      this.isSubmitDisabled = false;

      if (response) {
        let result = JSON.parse(response);
        if (Array.isArray(result)) result = result[0];

        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        // specialist user has been logged in successfully
        localStorage.setItem('specialist-info', JSON.stringify(result));
        this.otherService.changeSpecialistUserLogin_Status(result);
        this.accountService.toastSwal('success', `${result.strFullName} خوش آمدید`);
        this.router.navigateByUrl('/specialist-verification');
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  async forgetPassword(phoneNumberField: NgModel) {
    if (phoneNumberField.invalid || phoneNumberField.pristine || this.isSubmitDisabled) {
      return;
    }

    const result = await Swal.fire({
      title: 'آیا اطمینان دارید؟',
      text: 'آیا از انجام عملیات فراموشی رمز عبور اطمینان دارید؟',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonColor: '#10b981',
      confirmButtonText: 'تایید',
      cancelButtonText: 'بستن',
    });

    if (!result.isConfirmed) {
      return;
    }

    const model = {
      strMobile: this.fields.strMobile,
    };

    this.accountService.specialistForgetPassword(model).pipe(
      catchError(() => of(false)),
      takeUntil(this.unSubscribeAll$),
    ).subscribe((response: string | false) => {
      if (response) {
        let result = JSON.parse(response);
        if (Array.isArray(result)) result = result[0];

        if (result.iResult === 0) {
          return this.accountService.toastSwal('error', result.strError);
        }

        this.accountService.toastSwal('success', 'رمز عبور تا ثانیه های دیگر برای شما پیامک می شود');
      } else {
        this.accountService.toastSwal('error', 'خطایی رخ داد');
      }
    });
  }

  unSubscribeAll(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll();
  }
}
